class ProductGallerySliderController {
  constructor() {
    this.galleryContainerSelector = '[gallery-container]';
    this.mainGallerySelector = '[main-gallery-swiper]';
    this.thumbGallerySelector = '[thumb-gallery-swiper]';
    this.startInitialisation();
  }

  startInitialisation() {
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      if (window.customElements.get('swiper-container')) {
        this.init();
      } else {
        window.customElements.whenDefined('swiper-container').then(() => {
          this.init();
        }).catch((error) => {
          console.warn('ProductGallerySliderController: Failed to wait for swiper-container', error);
          this.markGalleryReady();
        });
      }
    } else {
      this.init();
    }
  }

  init() {
    this.galleryContainer = document.querySelector(this.galleryContainerSelector);
    if (!this.galleryContainer) {
      console.warn('ProductGallerySliderController: Product gallery container not found');
      return;
    }

    this.main_gallery = this.galleryContainer.querySelector(this.mainGallerySelector);
    this.thumb_gallery = this.galleryContainer.querySelector(this.thumbGallerySelector);
    this.thumb_positioning = this.galleryContainer.getAttribute('data-thumb-positioning') || 'left';

    // If thumb gallery not found with primary selector, try alternative selectors
    if (!this.thumb_gallery) {
      const alternativeSelectors = [
        'swiper-container[data-thumb]',
        'swiper-container.thumb-swiper',
        '.thumb-gallery swiper-container',
        '[data-thumb-swiper]',
        '#product-thumb-swiper',
        'swiper-container:nth-child(2)'
      ];

      for (const selector of alternativeSelectors) {
        this.thumb_gallery = this.galleryContainer.querySelector(selector);
        if (this.thumb_gallery) {
          break;
        }
      }
    }

    this.setupResizeListener();
    this.initGallery();
  }

  syncThumbHeight() {
    // Don't run height syncing if thumb positioning is set to 'under'
    if (this.thumb_positioning === 'under') {
      return;
    }

    if (!this.main_gallery || !this.thumb_gallery) {
      return;
    }

    // Get the computed height of the main swiper
    const mainHeight = this.main_gallery.getBoundingClientRect().height;

    if (mainHeight > 0) {
      // Apply this height to the thumb gallery container
      const thumbGallery = this.thumb_gallery.closest('.thumb-gallery');

      if (thumbGallery) {
        // Force specific height constraints
        thumbGallery.style.height = mainHeight + 'px';
        thumbGallery.style.maxHeight = mainHeight + 'px';
        thumbGallery.style.minHeight = mainHeight + 'px';
        thumbGallery.style.overflow = 'hidden';

        // Force thumb swiper constraints
        this.thumb_gallery.style.height = '100%';
        this.thumb_gallery.style.maxHeight = '100%';
        this.thumb_gallery.style.overflow = 'hidden';

        // Force swiper wrapper constraints via CSS injection
        this.injectThumbSwiperStyles(mainHeight);

        // Update swiper if it exists
        if (this.thumb_gallery.swiper && typeof this.thumb_gallery.swiper.update === 'function') {
          this.thumb_gallery.swiper.update();
        }
      }
    }
  }

  injectThumbSwiperStyles(mainHeight) {
    if (!this.thumb_gallery.id) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'thumb-swiper-height-fix';
    style.textContent = `
      #${this.thumb_gallery.id} {
        height: ${mainHeight}px !important;
        max-height: ${mainHeight}px !important;
      }
      #${this.thumb_gallery.id}::part(wrapper) {
        height: 100% !important;
        max-height: 100% !important;
        flex-direction: column !important;
      }
    `;

    // Remove existing style if present
    const existingStyle = document.getElementById('thumb-swiper-height-fix');
    if (existingStyle) {
      existingStyle.remove();
    }
    document.head.appendChild(style);
  }

  setupResizeListener() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.syncThumbHeight();
      }, 250);
    });
  }

  markGalleryReady() {
    if (this.galleryContainer) {
      this.galleryContainer.classList.remove('opacity-0');
      this.galleryContainer.classList.add('opacity-1');
    }
  }

  initialiseSwiperElement(el) {
    if (!el) {
      return Promise.resolve(null);
    }

    if (el.swiper) {
      return Promise.resolve(el.swiper);
    }

    if (typeof el.initialize === 'function') {
      try {
        const initResult = el.initialize();
        if (initResult && typeof initResult.then === 'function') {
          return initResult.then(() => {
            return el.swiper || null;
          });
        }
        return Promise.resolve(el.swiper || null);
      } catch (error) {
        console.error('ProductGallerySliderController: Error during element initialization:', error);
        return Promise.reject(error);
      }
    }

    return Promise.resolve(null);
  }

  initGallery() {
    const thumbPromise = this.initialiseSwiperElement(this.thumb_gallery);
    thumbPromise
      .then(() => {
        return this.initialiseSwiperElement(this.main_gallery);
      })
      .then((mainSwiperInstance) => {
        if (mainSwiperInstance) {
          window.gallery_swiper = mainSwiperInstance;
        }
        if (this.thumb_gallery && this.thumb_gallery.swiper) {
          window.gallery_thumb_swiper = this.thumb_gallery.swiper;
        }

        this.markGalleryReady();

        // Sync height after initialization
        setTimeout(() => {
          this.syncThumbHeight();
        }, 100);
      })
      .catch((error) => {
        console.error('ProductGallerySliderController: Failed to initialise Swiper:', error);
        this.markGalleryReady();
      });
  }



}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductGallerySliderController(), { once: true });
} else {
  new ProductGallerySliderController();
}
// (function () {
//   var galleryContainer = document.getElementById('{{ gallery_container_id }}');
//   var mainSwiperEl = document.getElementById('{{ main_swiper_id }}');
//   var thumbSwiperEl = document.getElementById('{{ thumb_swiper_id }}');
//   var thumbPositioning = '{{ thumb_positioning | default: "side" }}';

//   if (!galleryContainer || !mainSwiperEl) {
//     return;
//   }

//   var syncThumbHeight = function() {
//     // Don't run height syncing if thumb positioning is set to 'under'
//     if (thumbPositioning === 'under') {
//       return;
//     }

//     if (!mainSwiperEl || !thumbSwiperEl) return;

//     // Get the computed height of the main swiper
//     var mainHeight = mainSwiperEl.getBoundingClientRect().height;

//     if (mainHeight > 0) {
//       // Apply this height to the thumb gallery container
//       var thumbGallery = thumbSwiperEl.closest('.thumb-gallery');
//       if (thumbGallery) {
//         // Force specific height constraints
//         thumbGallery.style.height = mainHeight + 'px';
//         thumbGallery.style.maxHeight = mainHeight + 'px';
//         thumbGallery.style.minHeight = mainHeight + 'px';
//         thumbGallery.style.overflow = 'hidden';

//         // Force thumb swiper constraints
//         thumbSwiperEl.style.height = '100%';
//         thumbSwiperEl.style.maxHeight = '100%';
//         thumbSwiperEl.style.overflow = 'hidden';

//         // Force swiper wrapper constraints via CSS injection
//         var style = document.createElement('style');
//         style.id = 'thumb-swiper-height-fix';
//         style.textContent = `
//           #${thumbSwiperEl.id} {
//             height: ${mainHeight}px !important;
//             max-height: ${mainHeight}px !important;
//           }
//           #${thumbSwiperEl.id}::part(wrapper) {
//             height: 100% !important;
//             max-height: 100% !important;
//             flex-direction: column !important;
//           }
//         `;

//         // Remove existing style if present
//         var existingStyle = document.getElementById('thumb-swiper-height-fix');
//         if (existingStyle) {
//           existingStyle.remove();
//         }
//         document.head.appendChild(style);

//         // Update swiper if it exists
//         if (thumbSwiperEl.swiper && typeof thumbSwiperEl.swiper.update === 'function') {
//           thumbSwiperEl.swiper.update();
//         }
//       }
//     }
//   };

//   var markGalleryReady = function () {
//     galleryContainer.classList.remove('opacity-0');
//     galleryContainer.classList.add('opacity-1');
//   };

//   var initialiseSwiperElement = function (el) {
//     if (!el) {
//       return Promise.resolve(null);
//     }
//     if (el.swiper) {
//       return Promise.resolve(el.swiper);
//     }
//     if (typeof el.initialize === 'function') {
//       try {
//         var initResult = el.initialize();
//         if (initResult && typeof initResult.then === 'function') {
//           return initResult.then(function () {
//             return el.swiper || null;
//           });
//         }
//         return Promise.resolve(el.swiper || null);
//       } catch (error) {
//         return Promise.reject(error);
//       }
//     }
//     return Promise.resolve(null);
//   };

//   var initGallery = function () {
//     var thumbPromise = initialiseSwiperElement(thumbSwiperEl);
//     thumbPromise
//       .then(function () {
//         return initialiseSwiperElement(mainSwiperEl);
//       })
//       .then(function (mainSwiperInstance) {
//         if (mainSwiperInstance) {
//           window.gallery_swiper = mainSwiperInstance;
//         }
//         if (thumbSwiperEl && thumbSwiperEl.swiper) {
//           window.gallery_thumb_swiper = thumbSwiperEl.swiper;
//         }

//         markGalleryReady();

//         // Sync height after initialization
//         setTimeout(function() {
//           syncThumbHeight();
//         }, 100);
//       })
//       .catch(function (error) {
//         console.warn('Product gallery: failed to initialise Swiper', error);
//         markGalleryReady();
//       });
//   };

//   // Add resize listener to sync height on window resize
//   var resizeTimeout;
//   window.addEventListener('resize', function() {
//     clearTimeout(resizeTimeout);
//     resizeTimeout = setTimeout(function() {
//       syncThumbHeight();
//     }, 250);
//   });

//   var startInitialisation = function () {
//     if (window.customElements && typeof window.customElements.whenDefined === 'function') {
//       if (window.customElements.get('swiper-container')) {
//         initGallery();
//       } else {
//         window.customElements.whenDefined('swiper-container').then(initGallery).catch(markGalleryReady);
//       }
//     } else {
//       initGallery();
//     }
//   };

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', startInitialisation, { once: true });
//   } else {
//     startInitialisation();
//   }
// })();